"use client"
import Linked from '@/components/shared/Linked'
import { LinkType } from '@/libs/types'
import React from 'react'
interface ContentButtonProps {
    linked: LinkType
    locale: string
}

const ContentButton: React.FC<ContentButtonProps> = ({
    linked,
    locale
}) => {
    const handleReplacePathname = (event: any, linked: any) => {
        if (linked?.target === null) {
            event.preventDefault();
            // console.log(location, event.target);
            const target = document.getElementById(linked?.href.split("#")[1]);
            target?.scrollIntoView();
            // router.push(location.pathname, undefined, { shallow: true });
        }
    }
    return (
        <div className="d-flex content-button">
            <Linked linked={linked}
                className={[linked?.button ? "btn-demo w-100 btn-small fw-semi-bold" : "d-flex my-auto talk-with-expert text-orange"].join(" ")}
                locale={locale} clicker={() => handleReplacePathname(event, linked)} />
        </div>
    )
}

export default ContentButton